// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b5199b27","18":"5ea17b6e","380":"03575968","453":"79ec2a8e","711":"f5880201","910":"4616a6a5"}[chunkId] + ".chunk.js";
};